import { Dialog } from "@smartsuite/react-ui/lib";
import React from "react";

import { $t } from "../../utils/intl";

import "./FormErrorMessage.sass";
import { FormErrorMessageText } from "./FormErrorMessage.text";

interface FormErrorMessageProps {
  statusCode?: number;
}

export const FormErrorMessage: React.FC<FormErrorMessageProps> = ({ statusCode }) => {
  const isPaymentRequired = statusCode === 402;

  const header = isPaymentRequired
    ? $t(FormErrorMessageText.paymentRequiredHeader)
    : $t(FormErrorMessageText.genericHeader);

  const description = isPaymentRequired
    ? $t(FormErrorMessageText.paymentRequiredDescription)
    : $t(FormErrorMessageText.genericDescription);

  return (
    <div className="form-error-message">
      <img
        src="/form/images/form-404-rectangles.svg"
        alt={$t(FormErrorMessageText.imgAlt)}
        className="form-error-message__background-image"
      />
      <Dialog.Wrapper type="warning">
        <Dialog.Image background="red" url="/form/images/form-404-sad.svg" />
        <Dialog.Header>
          <Dialog.Header.Heading text={header} />
          <Dialog.Header.Description text={description} />
        </Dialog.Header>

        {!isPaymentRequired && Boolean(statusCode) && (
          <div className="form-error-message__actions">
            <span className="form-error-message__code">
              {$t(FormErrorMessageText.errorCode, { statusCode })}
            </span>
          </div>
        )}
      </Dialog.Wrapper>
    </div>
  );
};
